<template>
  <div class="content">
    <h1 style="text-align:center">盘股服务协议及<br/>隐私保护政策</h1>

    <p>感谢选择盘股为您提供服务！</p>

    <p>
      盘股是由财通证券股份有限公司开发的股权服务应用，在企业用户使用本应用过程中，双方
    </p>

    <p>
      &nbsp;欢迎您使用由财通证券股份有限公司开发的股权服务应用，财通证券（以下也称&ldquo;我们&rdquo;）深知个人信息对您的重要性，因此我们非常尊重并保护您的个人隐私权。为了给您提供更准确、更有个性化的服务，本应用会按照本隐私权政策的规定使用和披露您的个人信息。但本应用将以高度的勤勉、审慎义务对待这些信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，本应用不会将这些信息对外披露或向第三方提供。在您使用本应用前，我们将按照法律法规要求并通过《盘股服务协议及隐私保护政策》（以下简称&ldquo;本政策&rdquo;）向您说明我们在您使用财通企财通App的股权服务时如何收集、保护、使用您的个人信息，其中要点如下：
    </p>

    <p>
      <strong><strong>一、收集信息 </strong></strong>
    </p>

    <p>
      在您通过财通企财通App使用股权服务时，您需要/可以选择授权我们收集和使用个人的情形包括：
    </p>

    <p>1.&nbsp;您需要授权我们收集和使用的信息</p>

    <p>
      1.1为了向您提供我们产品/服务的基本功能，您需要授权我们收集、使用必要信信息的情形。如您拒绝提供前述必要信息，您将无法正常使用我们的产品/服务。基本功能包括但不限于激励计划协议签署、期权/股权查询及交易等服务
    </p>

    <p>
      1.2为了向您提供我们产品/服务的附加功能，您需要授权我们收集、使用必要信信息的情形。如您拒绝提供前述必要信息，您将无法正常使用相关附加功能或实现我们拟达到的功能效果，但并不会影响您正常使用我们产品/服务的基本功能。
    </p>

    <p>2.&nbsp;您在使用服务过程中产生的信息</p>

    <p>
      <strong
        ><strong
          >请您注意，基于向您提供更好的产品和服务的目的，我们可能会不时推出新的或优化后的功能，可能增加或变更收集和使用对应信息的目的、范围和方式，并为您提供同意与否的选项，且在征得您的同意后收集、使用对应信息</strong
        ></strong
      >。
    </p>

    <p>
      2.1为使您获得更舒适的访问体验，系统可能自动采集您每次点击、访问的页面，以及您在使用我们服务时浏览或要求提供的其他信息。
    </p>

    <p>
      2.2为向您提供更便捷更安全的交易服务，并且依据相关法律法规协助并保障您所在的企业或组织更好地实施及管理激励计划，
      您需要在激励计划授予的已解除限售的权益发生交易后，主动将相关交易数据提交到系统中，并且授权我们将其仅共享给您所在的企业或组织。
    </p>

    <p>3.&nbsp;您可选择是否授权我们收集和使用您的个人信息</p>

    <p>
      <strong
        ><strong
          >3.1为向您提供更便捷更安全的交易服务，并且依据相关法律法规协助并保障您所在的企业或组织更好地实施及管理激励计划，您需要在激励计划授予的已解除限售的权益发生交易后，主动将相关交易数据提交到系统中，并且授权我们将其仅共享给您所在的企业或组织</strong
        ></strong
      ><strong><strong>。</strong></strong>
    </p>

    <p>
      4.您充分知晓，根据相关法律法规规定，在如下情形中，我们可能会依法收集并使用您的个人信息而无需征得您的授权同意：
    </p>

    <ol>
      <li>
        <strong><strong>与国家安全、国防安全直接相关的；</strong></strong>
      </li>
      <li>
        <strong
          ><strong
            >与公共安全、公共卫生、重大公共利益直接相关的；</strong
          ></strong
        >
      </li>
      <li>
        <strong
          ><strong
            >与犯罪侦查、起诉、审判和判决执行等直接相关的；</strong
          ></strong
        >
      </li>
      <li>
        <strong
          ><strong
            >出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</strong
          ></strong
        >
      </li>
      <li>
        <strong
          ><strong>所涉及的个人信息是您自行向社会公众公开的；</strong></strong
        >
      </li>
      <li>
        <strong><strong>根据您的要求签订和履行合同所必需的；</strong></strong>
      </li>
      <li>
        <strong
          ><strong
            >从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道</strong
          ></strong
        >
      </li>
      <li>
        <strong
          ><strong
            >维护所提供产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障。</strong
          ></strong
        >
      </li>
    </ol>

    <p>
      <strong><strong>二、使用信息 </strong></strong>
    </p>

    <ol>
      <li>
        我们会根据本协议的约定并为实现我们的产品与/或服务功能对所收集的个人信息进行使用；
      </li>
      <li>
        为了保障服务的稳定性与安全性，我们会将您的信息用于安全防范、交易监测、预防或禁止非法活动、降低风险、存档和备份用途；
      </li>
      <li>根据法律法规或监管要求向相关部门进行报告；</li>
      <li>
        在收集您的个人信息后，我们将通过技术手段对数据进行脱敏、去标识化处理，
        去标识化处理的信息将无法识别主体。请您了解并同意，
        在此情况下我们可以对您的信息进行综合统计、分析加工，以便为您提供更加准确、个性、流畅及便捷的服务，或帮助我们评估、改善或涉及服务及运营活动；
      </li>
      <li>
        请您注意，您在使用我们的产品与/或服务时所提供的所有个人信息，
        除非您删除或拒绝我们收集，否则将在您使用我们的产品与/或服务期间持续授权我们使用；
      </li>
      <li>
        我们会对我们的产品与/或服务使用情况进行统计，
        并可能会与公众或第三方共享这些统计信息，以展示我们的产品与/或服务的整体使用趋势。但这些统计信息不包含您的任何身份识别信息；
      </li>
      <li>
        当我们要将您的个人信息用于本协议未载明的其他用途时，
        或基于特定目的收集而来的信息用于其他目的时，会按照法律法规及国家标准的要求以确认协议、具体场景下的文案确认动作等形式再次征求您的同意。
      </li>
    </ol>

    <p>
      <strong><strong>3.披露信息</strong></strong>
    </p>

    <p>
      在如下情况下，本应用将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：
    </p>

    <ol>
      <li>事先征得您的明确同意或授权；</li>
      <li>为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；</li>
      <li>
        根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；
      </li>
      <li>
        在本应用平台上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，本应用有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成或纠纷的解决。
      </li>
      <li>其它本应用根据法律、法规或者网站政策认为合适的披露。</li>
    </ol>

    <p>
      <strong><strong>4</strong></strong
      ><strong><strong>.</strong></strong
      ><strong><strong>信息安全</strong></strong>
    </p>

    <p>
      1.
      本应用帐号均有安全保护功能，请妥善保管您的用户名及密码信息。本应用会使用加密技术等安全措施确保数据的保密性，并确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您注意在信息网络上不存在&ldquo;完善的安全措施&rdquo;。
    </p>

    <p>
      <strong><strong>5</strong></strong
      ><strong><strong>.本隐私政策的更改</strong></strong>
    </p>

    <p>
      如果决定更改隐私政策，我们会在适当的位置发布这些更改，以便您了解我们如何收集、使用您的个人信息，哪些人可以访问这些信息，以及在什么情况下我们会透露这些信息。您知悉并确认，即视为同意接受变动内容，我们将继续为您提供服务。如您不同意更新后的内容，我们将立即停止提供本应用相应服务。
    </p>

    <p>&nbsp;</p>

    <p>&nbsp;</p>

    <p>&nbsp;</p>
  </div>
</template>

<script>
document.title = "盘股服务协议及隐私保护政策";
export default {
  name: "QctServiceProtocal",
  mounted: function () {},
  data: function () {
    return {
      // uaInfo: "",
    };
  },
};
</script>

<style scoped>
.content {
  padding: 60px;
}
</style>
